import { ImageVariantProps } from './Types'
import { ArtisticFilterVariant } from './ArtisticFilterVariant'
import { BrightnessVariant } from './BrightnessVariant'
import { ContrastVariant } from './ContrastVariant'
import { BlurVariant } from './BlurVariant'
import { CartoonifyVariant } from './CartoonifyVariant'
import { PixelateVariant } from './PixelateVariant'
import { OilPaintVariant } from './OilPaintVariant'
import { SharpenVariant } from './SharpenVariant'
import { VignetteVariant } from './VignetteVariant'
import { SepiaVariant } from './SepiaVariant'
import { AutoBrightnessVariant } from './AutoBrightnessVariant'
import { AutoContrastVariant } from './AutoContrastVariant'
import { ArtisticFilterVariant as IArtisticFilterVariant, ImageEffectEffectVariant } from 'stores/ImageStore'
import { RGBVariant } from './RGBVariant'
import { SaturationVariant } from './SaturationVariant'
import { GenerativeRemoveVariant } from 'common/Prose/nodeViews/Image/components/ImageVariant/GenerativeRemoveVariant'
import { GenerativeBackgroundReplaceVariant } from 'common/Prose/nodeViews/Image/components/ImageVariant/GenerativeBackgroundReplaceVariant'

export const ActionImageVariant = ({ variant, ...props }: ImageVariantProps) => {
  switch (variant.action) {
    case 'artistic_filter':
      return <ArtisticFilterVariant {...props} variant={variant as IArtisticFilterVariant} />
    case 'brightness':
      return <BrightnessVariant {...props} variant={variant as ImageEffectEffectVariant<'brightness', number>} />
    case 'contrast':
      return <ContrastVariant {...props} variant={variant as ImageEffectEffectVariant<'contrast', number>} />
    case 'auto_brightness':
      return (
        <AutoBrightnessVariant {...props} variant={variant as ImageEffectEffectVariant<'auto_brightness', number>} />
      )
    case 'auto_contrast':
      return <AutoContrastVariant {...props} variant={variant as ImageEffectEffectVariant<'auto_contrast', number>} />
    case 'red':
    case 'green':
    case 'blue':
      return <RGBVariant {...props} variant={variant as ImageEffectEffectVariant<'red' | 'green' | 'blue', number>} />
    case 'blur':
      return <BlurVariant {...props} variant={variant as ImageEffectEffectVariant<'blur', number>} />
    case 'saturation':
      return <SaturationVariant {...props} variant={variant as ImageEffectEffectVariant<'saturation', number>} />
    case 'sepia':
      return <SepiaVariant {...props} variant={variant as ImageEffectEffectVariant<'sepia', number>} />
    case 'cartoonify':
      return <CartoonifyVariant {...props} variant={variant as ImageEffectEffectVariant<'cartoonify', number>} />
    case 'pixelate':
      return <PixelateVariant {...props} variant={variant as ImageEffectEffectVariant<'pixelate', number>} />
    case 'oil_paint':
      return <OilPaintVariant {...props} variant={variant as ImageEffectEffectVariant<'oil_paint', number>} />
    case 'sharpen':
      return <SharpenVariant {...props} variant={variant as ImageEffectEffectVariant<'sharpen', number>} />
    case 'vignette':
      return <VignetteVariant {...props} variant={variant as ImageEffectEffectVariant<'vignette', number>} />
    case 'generative_remove':
      return <GenerativeRemoveVariant {...props} variant={variant as ImageEffectEffectVariant<'generative_remove'>} />
    case 'generative_background_replace':
      return (
        <GenerativeBackgroundReplaceVariant
          {...props}
          variant={variant as ImageEffectEffectVariant<'generative_background_replace'>}
        />
      )
    default:
      return null
  }
}
